const boxTruckVehicles = [
    { name: 'Select Vehicle', disabled: true },
    { name: 'Chevrolet', disabled: false },
    { name: 'Ford', disabled: false },
    { name: 'Freightliner',  disabled: false },
    { name: 'GMC', disabled: false },
    { name: 'Hino', disabled: false },
    { name: 'International', disabled: false },
    { name: 'Isuzu', disabled: false },
    { name: 'Kenworth', disabled: false },
    { name: 'Mack', disabled: false },
    { name: 'Mercedes-Benz', disabled: false },
    { name: 'Mitsubishi Fuso', disabled: false },
    { name: 'Nissan', disabled: false },
    { name: 'Peterbilt', disabled: false },
    { name: 'Ram', disabled: false },
    { name: 'Scania', disabled: false },
    { name: 'Volvo', disabled: false }
];
export default boxTruckVehicles;
